"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FourthCircleStep = void 0;
const react_1 = __importDefault(require("react"));
const organisms_1 = require("../../../components/organisms");
const FourthCircleStep = (props) => {
    const { userInformation } = props;
    return (react_1.default.createElement(organisms_1.TimelineEntry, { checked: true, title: "Letzter Termin", subTitle: new Date(userInformation?.appointment[userInformation?.appointment.length - 1].startDate).toLocaleDateString('de-DE', {
            day: '2-digit',
            month: 'long',
        }), infoText: "Termin hatte stattgefunden" }));
};
exports.FourthCircleStep = FourthCircleStep;
